import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from "next-themes"

/**
 * ThemeProvider wrapper for next-themes
 * Prevents FOUC via inline script in index.html
 * Uses localStorage to persist theme preference
 */
export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider 
      attribute="class" 
      defaultTheme="system"
      enableSystem={true}
      storageKey="voy-theme"
      {...props}
    >
      {children}
    </NextThemesProvider>
  )
}